exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-4e9b6b84],th[data-v-4e9b6b84]{width:120px}", ""]);

// exports
